export const ApplicantDeleteIcon = ({
  primaryColor = 'var(--primary-bg-color)',
  secondColor = 'var(--primary-background-text-color',
}) => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g
        id="Group_45075"
        data-name="Group 45075"
        transform="translate(-1630 -203)"
      >
        <g
          id="Group_45025"
          data-name="Group 45025"
          transform="translate(462 40)"
        >
          <circle
            id="Ellipse_1247"
            data-name="Ellipse 1247"
            cx="24"
            cy="24"
            r="24"
            transform="translate(1168 163)"
            fill={primaryColor}
          />
        </g>
        <g id="trash" transform="translate(1598.479 217.742)">
          <path
            id="Path_65946"
            data-name="Path 65946"
            d="M61.6,2.314H58.414V1.736A1.736,1.736,0,0,0,56.678,0H54.364a1.736,1.736,0,0,0-1.736,1.736v.579H49.446A1.446,1.446,0,0,0,48,3.761V4.918a.579.579,0,0,0,.579.579H62.464a.579.579,0,0,0,.579-.579V3.761A1.446,1.446,0,0,0,61.6,2.314Zm-7.81-.579a.579.579,0,0,1,.579-.579h2.314a.579.579,0,0,1,.579.579v.579H53.786Z"
            fill={secondColor}
          />
          <path
            id="Path_65947"
            data-name="Path 65947"
            d="M73.545,184a.181.181,0,0,0-.181.189l.477,10.018a1.733,1.733,0,0,0,1.733,1.653h8.786a1.733,1.733,0,0,0,1.733-1.653l.477-10.018a.181.181,0,0,0-.181-.189Zm8.737,1.446a.579.579,0,0,1,1.157,0v7.521a.579.579,0,1,1-1.157,0Zm-2.893,0a.579.579,0,0,1,1.157,0v7.521a.579.579,0,1,1-1.157,0Zm-2.893,0a.579.579,0,0,1,1.157,0v7.521a.579.579,0,1,1-1.157,0Z"
            transform="translate(-24.447 -177.347)"
            fill={secondColor}
          />
        </g>
      </g>
    </svg>
  );
};
